import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { Inbox, Mail, Star } from "lucide-react";
import MessagesBoard from "./MessagesBoard";

const InboxTab = ({ 
  messages, 
  starredMessages, 
  toggleStar, 
  onSelectMessage = () => {},
}) => {
  const [activeTab, setActiveTab] = useState("All");

  const TabLabel = ({ text, icon: Icon, count }) => (
    <div className="flex items-center justify-center gap-2">
      <Icon className="h-4 w-4" />
      <span className="text-sm font-medium">{text} ({count})</span>
    </div>
  );

  const starredCount = Object.values(starredMessages).filter(Boolean).length;
  const unreadCount = messages?.filter((ticket) => ticket.tic_is_seen === 0 || !ticket.tic_is_seen).length || 0;

  const tabOptions = [
    { label: <TabLabel icon={Inbox} text="All" count={messages?.length || 0} />, value: "All" },
    { label: <TabLabel icon={Mail} text="Unread" count={unreadCount} />, value: "Unread" },
    { label: <TabLabel icon={Star} text="Starred" count={starredCount} />, value: "Starred" },
  ];

  const filteredMessages = () => {
    if (!messages) return [];
    
    if (activeTab === "Unread") {
      return messages.filter((ticket) => ticket.tic_is_seen === 0 || !ticket.tic_is_seen);
    } else if (activeTab === "Starred") {
      return messages.filter((ticket) => starredMessages[ticket.tic_id]);
    }
    return messages;
  };

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs tabs={tabOptions} height="h-12" activeTab={activeTab} onChange={setActiveTab} />

      <div className="mt-3 space-y-4">
        <MessagesBoard
          messages={filteredMessages()}
          starredMessages={starredMessages}
          toggleStar={toggleStar}
          onSelectMessage={onSelectMessage}
        />
      </div>
    </div>
  );
};

export default InboxTab;